'use client';

import { useRef } from 'react';

import { cn } from 'cn';
import { useTranslations } from 'use-intl';

import {
  DEFAULT_LOGO_LOADING_SPEED,
  LOGO_PATHS,
  LOGO_VIEW_BOX,
} from './shared-ui-logo-loading.consts';
import { useLogoLoadingAnimation } from './shared-ui-logo-loading.hooks';
import type {
  LogoFrame,
  LogoLoadingProps,
} from './shared-ui-logo-loading.types';

interface Props extends LogoLoadingProps {
  frame: LogoFrame;
  dataTest: string;
}

const LogoLoading = ({
  frame,
  dataTest,
  speed = DEFAULT_LOGO_LOADING_SPEED,
  className,
}: Props) => {
  const t = useTranslations('Common');

  const svgRef = useRef<SVGSVGElement>(null);

  useLogoLoadingAnimation({ svgRef, frame, speed });

  return (
    <svg
      ref={svgRef}
      data-test={dataTest}
      // eslint-disable-next-line jsx-a11y/prefer-tag-over-role -- the paths are re-drawn every frame, which an <img> cannot do
      role='img'
      aria-label={t('loadingHeading')}
      viewBox={LOGO_VIEW_BOX}
      className={cn('size-6 shrink-0 fill-current text-neutral-800', className)}
    >
      {LOGO_PATHS.map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
};

export default LogoLoading;
